export const ANALYTICS_ADMISSION_OFFICE = '/analytics/admission-office' as const
